module.exports = __webpack_public_path__ + "img/img5.191cdcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img5.png
// module id = 180
// module chunks = 0